module.exports = __webpack_public_path__ + "img/mc_g.1b68db27.png";